import { Button, Form, Input } from 'antd';
import * as _ from 'lodash';
import * as React from 'react';
import { debounceRate } from '../../../config/config';

export interface IField {
  key: number;
  value: string;
  label?: string;
}

export interface IDynamicInputsProps {
  defaultFields?: Array<IField>;
  onChange: (fields: Array<IField>) => void;
  debounced?: boolean;
  disabled: boolean;
  editable: boolean;
  addonBefore?: any;
}

interface IDynamicInputsState {
  fields: Array<IField>;
}

export class DynamicInputs extends React.Component<IDynamicInputsProps, IDynamicInputsState> {
  public static defaultProps = {
    debounced: true
  };

  constructor(props: IDynamicInputsProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.state = {
      fields:
        props.defaultFields != undefined && Array.isArray(props.defaultFields)
          ? [...props.defaultFields]
          : [{ key: 0, value: '' }]
    };

    if (props.debounced) {
      this.onChange = _.debounce(this.onChange, debounceRate);
    }
  }

  public render() {
    const inputs = this.getFields().map((f, index) => {
      return (
        <Form.Item label={f.label} key={f.key}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Input
              disabled={this.props.disabled}
              addonBefore={this.props.addonBefore}
              name={'' + f.key}
              defaultValue={f.value}
              onChange={e => this.onChange(f.key, e.target.value)}
            />
            {index > 0 &&
              this.props.editable && (
                <Button 
                  danger={true}
                  disabled={this.props.disabled}
                  onClick={() => this.removeInput(f.key)}
                >
                  X
                </Button>
              )}
          </div>
        </Form.Item>
      );
    });

    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {inputs}
        {this.props.editable && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end'
            }}
          >
            <Button
              type="primary"
              shape="circle"
              icon="plus"
              disabled={this.props.disabled}
              size={'large'}
              onClick={() => this.addNewInput()}
            />
          </div>
        )}
      </div>
    );
  }

  private getFields() {
    return this.state.fields.sort((a, b) => {
      return a.key - b.key;
    });
  }

  private addNewInput() {
    const fields = [...this.getFields()];
    let biggestKey = -1;
    if (fields.length > 0) {
      biggestKey = fields[fields.length - 1].key;
    }

    fields.push({ key: biggestKey + 1, value: '' });

    this.setState({ fields });
    this.props.onChange(fields);
  }

  private removeInput(key: number) {
    const fields = [...this.getFields()].filter(f => f.key !== key);
    this.setState({ fields });
    this.props.onChange(fields);
  }

  private onChange(key: number, val: string) {
    const fields = [...this.state.fields];
    const index = fields.findIndex(f => f.key === key);
    fields[index].value = val;

    this.props.onChange(fields);
  }
}



// WEBPACK FOOTER //
// ./src/components/Others/DynamicInputs/DynamicInputs.tsx